/**
 * Find deep value of an object.
 *
 * @param {!Object} obj              The object to search.
 * @param {!string} path             The path to the property for the value you want.
 * @param {Any|undefined} defaultVal A default value that is returned if the property doesn't exist.
 * @return {Any|undefined}           The value of the property at the specified path,
 *                                   the provided default value, or undefined.
 *
 * @example
 *  getDeepValue(obj,'foo.bar')
 *  getDeepValue(obj,'foo.1.bar')
 *  getDeepValue(obj,'foo[0].baz')
 *  getDeepValue(obj,'foo[1][2]')
 *  getDeepValue(obj,"foo['bar'].baz")
 *  getDeepValue(obj,"foo['bar']['baz']")
 *  getDeepValue(obj,"foo.bar.0.baz[1]['2']['w'].aaa[\"f\"].bb")
 *  getDeepValue(obj, 'foo.bar', 'default')
 */
module.exports = function getDeepValue(obj, path, defaultVal) {
  var i, l;

  path = typeof path === 'string' ? path.split(/[\.\[\]\"\']{1,2}/) : '';

  if (obj) {
    for (i = 0, l = path.length; i < l; i++) {
      if (obj === undefined || obj === null || !obj.hasOwnProperty(path[i])) {
        return defaultVal;
      }
      obj = obj[path[i]];
    }
  }

  return obj === undefined ? defaultVal : obj;
};
